import type Stripe from 'stripe'
export const usePay = {
  confirmPrice({ userId, opt }) {
    return useAPI()
      .post(`users/${userId || useUser().id}/services`, { body: opt }) as Promise<{
        buy_length: number
        eur_amount: number
        fee: number
        rmb_amount: number
        type: string
        user_balance: number
        user_req: {
          buy_length: number
          all_pre: boolean
          dry_run: boolean
          plan_id: number | string
          promocode: string
          addon_plan_id?: number
        },
        ori_rmb_amount?: number
        ori_eur_amount?: number
        all_pre?: boolean
      }>
  },
  pingppCheckout({ opt, params }) {
    return useAPI()
      .post(`pingxx`, { body: opt, params })
  },
  createStripeWechat({ opt, params }) {
    return useAPI()
      .post(`stripe_wechat`, { body: opt, params })
  },
  createStripeAlipay({ opt, params }) {
    return useAPI()
      .post(`stripe_alipay`, { body: opt, params })
  },
  createYaband({ opt: { channel, opt }, params }) {
    // console.log(channel, opt)
    return useAPI()
      .post(`yaband_${channel}`, { body: opt, params })
  },
  createStripeCheckoutSession({ opt, params }) {
    console.log('params:...', `stripe/checkout-session`, { body: opt, params })
    return useAPI()
      .post(`stripe/checkout-session`, { body: opt, params })
  },
  createPaypal({ opt, params }) {
    return useAPI()
      .post(`paypal`, { body: opt, params })
  },
  createPaymentwall({ opt, params }) {
    return useAPI()
      .post(`paymentwall`, { body: opt, params })
  },
  createAdyen(opt) {
    return useAPI()
      .post(`adyen`, { body: opt })
  },
  createPayop(opt) {
    return useAPI()
      .post(`payop`, { body: opt })
  },
  checkPromoCode(opt) {
    return useAPI().get(`promocodes/${opt.promoCode}/discount`)
  },
  stripeCapture(opt) {
    return useAPI().post('stripe/capture', { body: opt })
  },
  adyenCapture(opt) {
    return useAPI().post('adyen/capture', { body: opt })
  },
  getPaypalRemoteDetails({ orderId, params }) {
    return useAPI().get(`paypal/${orderId}/remote-details`, { params })
  },
  getRMBPaymentCount({ userId }) {
    return useAPI().get(`users/${userId}/rmb_payment_count`)
  },
  getSavedProductList(query) {
    return useAPI().get(`finance/saved_product_list`, { params: query })
  },
  getStripeEvents(option: Stripe.EventListParams, startingAfter: {
    [key: string]: string
  }): {
    success: boolean
    error?: Error
    data?: Stripe.Event[]
  } {
    return useAPI().post(`stripe/events`, {
      body: {
        option,
        startingAfter
      }
    }) as any
  },
  getStripePaymentIntents(option: Stripe.PaymentIntentListParams, startingAfter: {
    [key: string]: string
  }): {
    success: boolean
    error?: Error
    data?: Stripe.PaymentIntent[]
  } {
    return useAPI().post(`stripe/payment_intents`, {
      body: {
        option,
        startingAfter
      }
    }) as any
  },
  // orderId
  getReviewHistory(opt): Promise<ReviewHistory[]> {
    return useAPI().get(`stripe/review_history`, {
      params: opt
    })
  }
}
